import cn from 'classnames'
import React, { FC, useEffect } from 'react'

import { useModal } from './context/useModal'

import styles from './Modal.module.scss'

interface ModalProps {
  show: boolean
  onClose: () => void
  classes?: {
    overlay?: string
    body?: string
  }
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  closeOnOutsideClick?: boolean
  content: React.ComponentType<any>
  contentProps?: object
}

export const Modal: FC<ModalProps> = ({
  show,
  onClose,
  classes,
  size = 'md',
  closeOnOutsideClick = true,
  content: ContentComponent,
  contentProps = {},
}) => {
  const { markModalAsClosed, markModalAsOpened } = useModal()

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (closeOnOutsideClick && e.target === e.currentTarget) {
      onClose()
    }
  }

  useEffect(() => {
    if (show) {
      markModalAsOpened()
    } else {
      markModalAsClosed()
    }

    return () => {
      if (show) {
        markModalAsClosed()
      }
    }
  }, [show, markModalAsClosed, markModalAsOpened])

  if (!show) return null

  return (
    <div className={cn(styles.modalOverlay, classes?.overlay)} onClick={handleOverlayClick}>
      <div className={cn(styles.modalBody, styles[`modal-${size}`], classes?.body)}>
        <ContentComponent {...contentProps} />
      </div>
    </div>
  )
}
